import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [order, setOrder] = useState(null);
  const { refresh } = useCart();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const tick = async () => {
      try {
        const r = await api.get(`/checkout/order/status/${sessionId}`);
        setOrder(r.data);
        if (r.data.status === "paid") {
          setStatus("paid");
          refresh();
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts < 10) setTimeout(tick, 2000);
      else setStatus("pending");
    };
    tick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-[#FAF9F7] py-20" data-testid="checkout-success">
      <div className="max-w-md w-full bg-white border border-[#E8E4DF] p-10 text-center mx-6">
        <div className="w-12 h-px bg-[#B8A88A] mx-auto mb-6"/>
        {status === "checking" && (
          <>
            <h1 className="font-display text-3xl mb-2">Confirmando seu pedido…</h1>
            <p className="text-sm text-[#6B6B6B]">Aguarde alguns instantes.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <p className="overline text-[#B8A88A] mb-3">Pedido confirmado</p>
            <h1 className="font-display text-3xl mb-3">Obrigada pela escolha</h1>
            <p className="text-sm text-[#6B6B6B] leading-relaxed mb-6">
              Sua peça já foi reservada para você. Enviaremos os detalhes da entrega para o e-mail informado.
            </p>
            {order?.order_id && <p className="overline text-xs text-[#A8A8A8] mb-6" data-testid="order-id">#{order.order_id}</p>}
            <Link to="/" className="btn-primary inline-flex">Voltar para a loja</Link>
          </>
        )}
        {status === "pending" && (
          <>
            <h1 className="font-display text-3xl mb-2">Aguardando confirmação</h1>
            <p className="text-sm text-[#6B6B6B]">O pagamento ainda não foi confirmado. Você receberá um e-mail assim que for processado.</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-display text-3xl mb-2">Sessão inválida</h1>
            <Link to="/" className="auth-link">Voltar para o início</Link>
          </>
        )}
      </div>
    </div>
  );
}
